"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1155ContractDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../inputs");
const Erc1155ContractDeployDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [3], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractTemplate", options: types_1.Erc1155ContractTemplates }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { required: true, name: "baseTokenURI" }), (0, jsx_runtime_1.jsx)(inputs_1.RoyaltyInput, {})] }));
};
exports.Erc1155ContractDeployDialog = Erc1155ContractDeployDialog;
//# sourceMappingURL=index.js.map